import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ArticleCard({ article, index = 0, featured = false }) {
  if (featured) {
    return (
      <Link
        to={`/insights/${article.slug}`}
        data-testid={`card-article-${article.slug}`}
        className="group grid grid-cols-1 md:grid-cols-12 gap-8 py-10 border-b border-rule hover:border-navy transition-colors"
      >
        <div className="md:col-span-5 relative overflow-hidden">
          <div className="aspect-[4/3] bg-mist overflow-hidden">
            {article.hero_image ? (
              <img
                src={article.hero_image}
                alt={article.title}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
              />
            ) : null}
          </div>
        </div>
        <div className="md:col-span-7 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="eyebrow text-gold">
                {String(index + 1).padStart(2, "0")} · {article.category}
              </span>
              <span className="text-xs text-ink-faint">
                · {article.read_time_minutes} min read
              </span>
            </div>
            <h3 className="font-serif text-3xl md:text-4xl leading-[1.1] tracking-tight text-navy mb-4 group-hover:text-navy/80 transition-colors">
              {article.title}
            </h3>
            {article.subtitle && (
              <p className="text-ink-muted text-base leading-relaxed max-w-xl mb-6">
                {article.subtitle}
              </p>
            )}
          </div>
          <div className="flex items-center gap-6">
            <div className="flex flex-wrap gap-2">
              {(article.tags || []).slice(0, 3).map((t) => (
                <span
                  key={t}
                  className="eyebrow text-ink-faint border border-rule px-3 py-1"
                >
                  {t}
                </span>
              ))}
            </div>
            <span className="ml-auto flex items-center gap-2 eyebrow text-navy group-hover:text-gold transition-colors">
              Read
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/insights/${article.slug}`}
      data-testid={`card-article-${article.slug}`}
      className="group flex flex-col border border-rule bg-paper hover:border-navy transition-colors"
    >
      <div className="aspect-[16/10] bg-mist overflow-hidden">
        {article.hero_image ? (
          <img
            src={article.hero_image}
            alt={article.title}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
          />
        ) : null}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-center justify-between mb-3">
          <span className="eyebrow text-gold">{article.category}</span>
          <span className="text-xs text-ink-faint">
            {article.read_time_minutes} min
          </span>
        </div>
        <h3 className="font-serif text-xl md:text-2xl leading-tight tracking-tight text-navy mb-3 group-hover:text-navy/80 transition-colors">
          {article.title}
        </h3>
        {article.excerpt && (
          <p className="text-sm text-ink-muted leading-relaxed mb-4 line-clamp-3">
            {article.excerpt}
          </p>
        )}
        <div className="mt-auto pt-4 border-t border-rule flex items-center justify-between">
          <div className="flex flex-wrap gap-1">
            {(article.tags || []).slice(0, 2).map((t) => (
              <span key={t} className="eyebrow text-ink-faint">
                {t}
              </span>
            ))}
          </div>
          <ArrowRight className="w-4 h-4 text-navy group-hover:translate-x-1 group-hover:text-gold transition-all" />
        </div>
      </div>
    </Link>
  );
}
